/**
 * The listing's Updated At column (spec R19).
 *
 * R19's `Mon-DD-YYYY` is a pinned PRESENTATION, not a locale preference
 * (operator decision 2026-08-18, matching the Guide table): every viewer sees
 * `Aug-18-2026`, so the column always reads like Guide's and the acceptance
 * oracles that quote it hold on any machine. This supersedes the earlier
 * split where non-en-US locales got their own `Intl` short date — that branch
 * is why the column silently rendered "Aug 18, 2026" on a browser reporting a
 * bare "en".
 *
 * The timezone hazard the original solved is still solved: `formatDate` reads
 * the date parts off the ISO string rather than through `new Date().getMonth()`,
 * which in a negative-offset timezone reports the previous day.
 */

import { DEFAULT_LOCALE, formatDate } from '../i18n';

export { EMPTY_DATE_PLACEHOLDER } from '../i18n';

export const formatUpdatedAt = (isoTimestamp: string): string =>
  formatDate(isoTimestamp, DEFAULT_LOCALE);
